import axios from 'axios'

/**
 * Logs an error to the console. If the error is an Axios error,
 * this will log the HTTP status code and the data returned by the server.
 *
 * @param {Error} error - The error to log.
 */
export function handleException(error) {
  if (axios.isAxiosError(error) && error.response) {
    const { status, data } = error.response
    console.error('Axios Error', status, data)
    return
  }

  console.error('Error', error.message)
}
